export const TIPOS_CONTA_BANCARIA = [
  { value: "CORRENTE", label: "Conta Corrente" },
  { value: "POUPANCA", label: "Poupanca" },
  { value: "PAGAMENTO", label: "Conta Pagamento" },
  { value: "INVESTIMENTO", label: "Investimento" },
  { value: "CAIXA", label: "Caixa" },
];

export const NATUREZAS_PLANO_CONTAS = [
  { value: "OPEX", label: "Opex" },
  { value: "CAPEX", label: "Capex" },
  { value: "FINANCE", label: "Financeiro" },
  { value: "OTHER", label: "Outros" },
];

export const NATUREZAS_CONTA = NATUREZAS_PLANO_CONTAS;

export const TIPOS_SOCIO = [
  { value: "ATIVO", label: "Socio Ativo" },
  { value: "INVESTIDOR", label: "Investidor" },
];

export const TIPOS_SOCIO_CONTRATO = [
  { value: "ACTIVE", label: "Ativo" },
  { value: "INVESTOR", label: "Investidor" },
];

export const STATUS_TAREFA_PTBR: Record<string, string> = {
  OPEN: "Aberta",
  IN_PROGRESS: "Em andamento",
  DONE: "Concluida",
  CANCELED: "Cancelada",
};
